import React, { useContext } from 'react';
import ClientOverviewComponent from "../../components/ClientOverviewComponent";
import { Panel } from "../../components/Panel";
import IconComponent from "../../components/IconComponent";
import { AppContext } from "../../context/AppContext";

export function ClientOverview() {
  const {
    getRoutes
  } = useContext(AppContext);

  /**
   * ROUTE_CONFIG
   */
  const ROUTE_CONFIG = getRoutes();

  return (
    <>
      <Panel
        header={
          <>
            <IconComponent iconName={ ROUTE_CONFIG.CLIENT_OVERVIEW.icon } />
            { ROUTE_CONFIG.CLIENT_OVERVIEW.title }
          </>
        }
      >
        <ClientOverviewComponent />
      </Panel>
    </>
  );
}
